import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Field, FieldError, FieldLabel } from '@/components/ui/field';
import type { Orientation, TLabelValue } from '@/components/form/form';
import { cn, toNumber } from '@/lib/utils';

type SelectProps = React.ComponentProps<typeof Select>;

type Props = {
  name: string;
  label?: string;
  className?: string;
  orientation?: Orientation;
  placeholder?: string;
  none?: boolean;
  items: TLabelValue[];
  number?: boolean;
  triggerClass?: string;
} & SelectProps;

const onChange = (val: any, field: any, number?: boolean) => {
  if (val === 'none') {
    val = '';
  }
  if (number) {
    val = toNumber(val);
  }
  field.onChange(val);
};

export function SelectField({
  label,
  name,
  className,
  orientation,
  items,
  none,
  number,
  placeholder,
  triggerClass,
  ...props
}: Props) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Field className={className} orientation={orientation} data-invalid={fieldState.invalid}>
          {label && <FieldLabel>{label}</FieldLabel>}
          <Select
            name={field.name}
            value={String(field.value)}
            onValueChange={(val) => onChange(val, field, number)}
            {...props}
          >
            <SelectTrigger
              data-placeholder={placeholder}
              aria-invalid={fieldState.invalid}
              className={cn('min-w-[120px]', triggerClass)}
            >
              <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
              {none && <SelectItem value="none">None</SelectItem>}
              {items.map((item) => (
                <SelectItem key={item.value} value={String(item.value)}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
        </Field>
      )}
    />
  );
}
